import { Controller } from "@hotwired/stimulus"
import ExcludedClients from "@components/invoice_reminders/excluded-clients.svelte"
import { mount, unmount } from "svelte"
import { isPreviewMode } from "@lib/utils"

const COMPONENT_KEY = "__svelteComponent"

// Connects to data-controller="excluded-clients-svelte"
export default class extends Controller {

  connect() {
    if (isPreviewMode()) return

    this.teardown()
    if (this.beforeCache) document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.beforeCache = () => this.teardown()
    document.addEventListener("turbo:before-cache", this.beforeCache)

    // Only include keys that were actually supplied on the element. Passing `null` (or "") for
    // a prop would override the Svelte component's default — destructuring defaults only apply
    // when the property is `undefined`.
    const { text, title } = this.element.dataset
    const props = {}
    if (text) props.text = text
    if (title) props.title = title

    const component = mount(ExcludedClients, { target: this.element, props })
    this.component = component
    this.element[COMPONENT_KEY] = component
  }

  disconnect() {
    if (this.beforeCache) {
      document.removeEventListener("turbo:before-cache", this.beforeCache)
      this.beforeCache = null
    }
    this.teardown()
  }

  teardown() {
    const existing = this.element[COMPONENT_KEY] || this.component
    if (existing) unmount(existing)
    this.element[COMPONENT_KEY] = null
    this.component = null
    this.element.innerHTML = ""
  }
}
